import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esAnxiety } from "@/pages/es/esConditionData1";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute("/es/anxiety-treatment-coral-springs-fl")({
  head: () => buildEsConditionHead(esAnxiety),
  component: RouteComponent,
});

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esAnxiety} />;
}
